import { faMinusCircle, faUser } from '@fortawesome/pro-regular-svg-icons';
import { Icon, Row, Spin } from 'antd';
import { differenceBy } from "lodash";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { AddRemoveContent, ColumnHeader, ContentItem, UsersList } from '../../../components';
import { AmplitudeEventsUtils, DataUtils, RoleGroupUtils } from '../../../utilities';
var GroupUsers = forwardRef(function (_a, ref) {
    var isMobileView = _a.isMobileView, selectedGroupData = _a.selectedGroupData, authentication = _a.authentication, updateGroupDetails = _a.updateGroupDetails, onload = _a.onload, isViewOnly = _a.isViewOnly;
    var activeGroup = selectedGroupData ? selectedGroupData : undefined;
    var userList = (selectedGroupData === null || selectedGroupData === void 0 ? void 0 : selectedGroupData.users) ? selectedGroupData === null || selectedGroupData === void 0 ? void 0 : selectedGroupData.users : undefined;
    var _b = useState({}), allUsers = _b[0], updateAllUsers = _b[1];
    var _c = useState(undefined), filteredUsers = _c[0], updateFilteredUsers = _c[1];
    var _d = useState(undefined), selectedUsers = _d[0], updateSelectedUsers = _d[1];
    var _e = useState([]), selectedGroupUsers = _e[0], updateSelectedGroupUsers = _e[1];
    var _f = useState(false), userListLoading = _f[0], toggleUserListLoading = _f[1];
    useEffect(function () {
        toggleUserListLoading(true);
        DataUtils.user(authentication).getAll({ view: "all" }).then(function (data) { return updateAllUsers(data.data); })
            .finally(function () { return toggleUserListLoading(false); });
    }, [authentication.selectedBrand]);
    useImperativeHandle(ref, function () { return ({
        resetStates: function () {
            resetAllStates();
        }
    }); });
    var addUsersToGroup = function (groupId, groupName, userList) {
        if (updateGroupDetails)
            updateGroupDetails(groupId, groupName, userList);
    };
    var filterUsersList = function (filterString) {
        if (allUsers && Array.isArray(allUsers)) {
            var usersWithoutAlreadyPresentUsers = differenceBy(allUsers, userList, "id");
            var filteredArray = usersWithoutAlreadyPresentUsers.filter(function (obj) {
                return RoleGroupUtils.matchNameWithSearchString(filterString, obj);
            });
            updateFilteredUsers(filteredArray);
        }
    };
    var handleUserSelection = function (userList) {
        if ((userList === null || userList === void 0 ? void 0 : userList.length) > 0) {
            updateSelectedUsers(userList);
        }
        else
            updateSelectedUsers(undefined);
    };
    var handleGroupUserSelection = function (userList) {
        if ((userList === null || userList === void 0 ? void 0 : userList.length) > 0)
            updateSelectedGroupUsers(userList);
        else
            updateSelectedGroupUsers([]);
    };
    var handleAddUsers = function () {
        var formattedList = [];
        if (selectedUsers) {
            for (var _i = 0, _a = (selectedUsers || []); _i < _a.length; _i++) {
                var user = _a[_i];
                var obj = {};
                obj.id = user;
                formattedList.push(obj);
            }
        }
        var finalList = userList.concat(formattedList);
        addUsersToGroup(activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.id, activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.name, finalList);
        updateSelectedUsers(undefined);
        updateSelectedGroupUsers([]);
        AmplitudeEventsUtils.manageGroupAddUser(activeGroup.name, formattedList.length);
    };
    var handleDeleteUsers = function () {
        if (!(selectedGroupUsers && selectedGroupUsers.length > 0)) {
            return;
        }
        var formattedList = [];
        if (selectedGroupUsers) {
            for (var _i = 0, selectedGroupUsers_1 = selectedGroupUsers; _i < selectedGroupUsers_1.length; _i++) {
                var user = selectedGroupUsers_1[_i];
                var obj = {};
                obj.id = user;
                formattedList.push(obj);
            }
        }
        var currentUsers = userList;
        var afterUsersDeletion = differenceBy(currentUsers, formattedList, "id");
        if (updateGroupDetails)
            updateGroupDetails(activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.id, activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.name, afterUsersDeletion);
        updateSelectedUsers(undefined);
        updateSelectedGroupUsers([]);
        AmplitudeEventsUtils.manageGroupRemoveUser(activeGroup.name, formattedList.length);
    };
    var removeAlreadyPresentUsers = function (userList, alreadyPresentList) {
        var usersWithoutAlreadyPresentUsers = differenceBy(userList, alreadyPresentList, "id");
        return usersWithoutAlreadyPresentUsers;
    };
    var onUserPopupClose = function () {
        resetAllStates();
    };
    var resetAllStates = function () {
        updateSelectedUsers(undefined);
        updateSelectedGroupUsers([]);
        updateFilteredUsers(undefined);
    };
    var usersListToView = filteredUsers && Array.isArray(filteredUsers) ? filteredUsers : removeAlreadyPresentUsers(allUsers, userList);
    var usersWithStatus = RoleGroupUtils.filterUsersByStatus(usersListToView, onload, true);
    var noGroupUsersSelected = !((selectedGroupUsers === null || selectedGroupUsers === void 0 ? void 0 : selectedGroupUsers.length) > 0);
    return React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(ColumnHeader, { icon: faUser, label: "Users", isMobileView: isMobileView })),
        !isViewOnly && React.createElement(Row, { style: { minHeight: "110px" } },
            React.createElement(AddRemoveContent, { addContentNode: {
                    node: React.createElement(ContentItem, { disabled: isViewOnly || !(activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.name), description: "Add users to group" }),
                    callback: handleAddUsers,
                    disabled: isViewOnly || !(activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.name)
                }, deleteContentNode: {
                    node: React.createElement(ContentItem, { disabled: isViewOnly || noGroupUsersSelected, color: "pink", iconName: faMinusCircle, description: "Remove selected users from group" }),
                    callback: handleDeleteUsers,
                    disabled: isViewOnly || noGroupUsersSelected
                }, containerType: "users", userData: React.createElement(Spin, { indicator: React.createElement(Icon, { type: "loading", spin: true, style: { fontSize: "1.5rem" } }), spinning: userListLoading },
                    React.createElement(UsersList, { userList: usersWithStatus.activeUsers || [], handleUserSelection: handleUserSelection, selectedUsers: selectedUsers || [], entityType: "group", userPopup: true })), filterUsersList: filterUsersList, selectedUsers: selectedUsers || [], handleUserSelection: handleUserSelection, onUserPopupClose: onUserPopupClose })),
        React.createElement(Row, null,
            React.createElement(UsersList, { isViewOnly: isViewOnly, entityType: "group", userList: userList, handleUserSelection: handleGroupUserSelection, selectedUsers: selectedGroupUsers })));
});
export default GroupUsers;
//# sourceMappingURL=index.js.map